import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, reactive } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Head from "@/components/Head/index.vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { ArrowRight } from "@element-plus/icons";
export default defineComponent({
  name: "BookDetail",
  components: {
    Head: Head,
    ArrowRight: ArrowRight
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var detail = reactive({
      data: {},
      chapter: [],
      totalNum: 0,
      chapterIndex: 0,
      currentPage: 1,
      chapterName: '',
      collect: 0
    });
    var id = route.query.id;
    var baseurl = process.env.VUE_APP_BASE_URL; //获取图书详情

    function getAllBookbyDetail() {
      return _getAllBookbyDetail.apply(this, arguments);
    } // 列表请求参数


    function _getAllBookbyDetail() {
      _getAllBookbyDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, code;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getAllBookbyDetail"]({
                  bookId: id
                });

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                code = _yield$globalProperti.code;

                if (code == 0) {
                  detail.data = data;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getAllBookbyDetail.apply(this, arguments);
    }

    var listParams = {
      pageIndex: 1,
      pageSize: 10
    };

    function changPage(val) {
      listParams.pageIndex = val;
      detail.currentPage = val;
      getAllBookbychapter();
    } //获取图书目录


    function getAllBookbychapter() {
      return _getAllBookbychapter.apply(this, arguments);
    } //获取读到那一章节


    function _getAllBookbychapter() {
      _getAllBookbychapter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti2, data, code, total;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getAllBookbychapter"](_objectSpread(_objectSpread({}, listParams), {}, {
                  bookId: id
                }));

              case 2:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                code = _yield$globalProperti2.code;
                total = _yield$globalProperti2.total;

                if (code == 0) {
                  detail.chapter = data;
                  detail.totalNum = total;
                  data.forEach(function (item) {
                    if (item.chapterId == detail.chapterIndex) {
                      detail.chapterName = item.chapterName;
                    }
                  });
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getAllBookbychapter.apply(this, arguments);
    }

    function getBookReadCatalog() {
      return _getBookReadCatalog.apply(this, arguments);
    } //查询图书是否收藏


    function _getBookReadCatalog() {
      _getBookReadCatalog = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$globalProperti3, data, code, num;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookReadCatalog"]({
                  bookId: id
                });

              case 2:
                _yield$globalProperti3 = _context3.sent;
                data = _yield$globalProperti3.data;
                code = _yield$globalProperti3.code;

                if (code == 0) {
                  if (data) detail.chapterIndex = data.chapterId;

                  if (data && data.chapterId <= 10 || !data) {
                    listParams.pageIndex = 1;
                    detail.currentPage = 1;
                  } else {
                    num = Math.ceil((detail.chapterIndex - 1) / 10);

                    if (detail.chapterIndex % 10 == 1) {
                      listParams.pageIndex = num + 1;
                      detail.currentPage = num + 1;
                    } else {
                      listParams.pageIndex = num;
                      detail.currentPage = num;
                    }
                  }

                  getAllBookbychapter();
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getBookReadCatalog.apply(this, arguments);
    }

    function getBookIscollect() {
      return _getBookIscollect.apply(this, arguments);
    }

    function _getBookIscollect() {
      _getBookIscollect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$globalProperti4, data, code;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookIscollect"]({
                  bookId: id
                });

              case 2:
                _yield$globalProperti4 = _context4.sent;
                data = _yield$globalProperti4.data;
                code = _yield$globalProperti4.code;

                if (code == 0) {
                  detail.collect = data;
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getBookIscollect.apply(this, arguments);
    }

    getAllBookbyDetail();
    getBookReadCatalog();
    getBookIscollect();

    function goRead(_x) {
      return _goRead.apply(this, arguments);
    }

    function _goRead() {
      _goRead = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(res) {
        var _yield$globalProperti5, code;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(detail.chapterIndex == 0)) {
                  _context5.next = 3;
                  break;
                }

                beginRead(res);
                return _context5.abrupt("return");

              case 3:
                detail.chapterIndex = res;
                _context5.next = 6;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookSaveCatalog"]({
                  bookId: id,
                  chapterId: detail.chapterIndex,
                  pageNum: 1,
                  totalPage: 1
                });

              case 6:
                _yield$globalProperti5 = _context5.sent;
                code = _yield$globalProperti5.code;

                if (code == 0) {
                  router.push({
                    name: "readBook",
                    query: {
                      id: id,
                      chapterId: detail.chapterIndex,
                      total: detail.totalNum
                    }
                  });
                }

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _goRead.apply(this, arguments);
    }

    function beginRead(_x2) {
      return _beginRead.apply(this, arguments);
    } //加入书架


    function _beginRead() {
      _beginRead = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(res) {
        var _yield$globalProperti6, code;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookSaveCatalog"]({
                  bookId: id,
                  chapterId: res,
                  pageNum: 1,
                  totalPage: 1
                });

              case 2:
                _yield$globalProperti6 = _context6.sent;
                code = _yield$globalProperti6.code;

                if (code == 0) {
                  router.push({
                    name: "readBook",
                    query: {
                      id: id,
                      chapterId: res,
                      total: detail.totalNum
                    }
                  });
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _beginRead.apply(this, arguments);
    }

    function joinBookCase() {
      return _joinBookCase.apply(this, arguments);
    } //移除书架


    function _joinBookCase() {
      _joinBookCase = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$globalProperti7, code;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookJoinBookcase"](id);

              case 2:
                _yield$globalProperti7 = _context7.sent;
                code = _yield$globalProperti7.code;

                if (code == 0) {
                  ElMessage({
                    message: "加入成功",
                    type: "success"
                  });
                  getAllBookbyDetail();
                  getBookIscollect();
                }

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _joinBookCase.apply(this, arguments);
    }

    function joinBookCasedel() {
      return _joinBookCasedel.apply(this, arguments);
    }

    function _joinBookCasedel() {
      _joinBookCasedel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _yield$globalProperti8, code;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMyBookcaseDel"](id);

              case 2:
                _yield$globalProperti8 = _context8.sent;
                code = _yield$globalProperti8.code;

                if (code == 0) {
                  ElMessage({
                    message: "移除成功",
                    type: "success"
                  });
                  getAllBookbyDetail();
                  getBookIscollect();
                }

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return _joinBookCasedel.apply(this, arguments);
    }

    return {
      baseurl: baseurl,
      detail: detail,
      getAllBookbyDetail: getAllBookbyDetail,
      getAllBookbychapter: getAllBookbychapter,
      joinBookCase: joinBookCase,
      joinBookCasedel: joinBookCasedel,
      beginRead: beginRead,
      goRead: goRead,
      changPage: changPage,
      getBookReadCatalog: getBookReadCatalog,
      getBookIscollect: getBookIscollect
    };
  }
});